import { useRovoWorkspace, useUnitsEnabled } from '@townsquare/collab-context';
import { useRouteDependencies } from '@townsquare/router/primitives/dependencies';
import { generatePath } from '@townsquare/router/primitives/path';
import { goalUpdateViewRoute } from '@townsquare/routes/goal-updates-view';
import { projectUpdateViewRoute } from '@townsquare/routes/project-updates-view';
import { createSearchParamsFromCurrentUrl } from '@townsquare/search-params';

import { useProjectsAndGoalsSite } from './use-projects-and-goals-site';

export const useStatusUpdatesPath = (): {
	statusUpdatesPath: string;
	isStatusUpdatesEnabled: any;
} => {
	const routeDependencies = useRouteDependencies();
	const {
		cloudId: statusUpdatesCloudId,
		hasProjectsAccess,
		hasGoalsAccess,
	} = useProjectsAndGoalsSite();
	const currentCloudId = useRovoWorkspace();
	const unitsEnabled = useUnitsEnabled();

	const hasStatusUpdatesInCurrentSite = statusUpdatesCloudId === currentCloudId;
	const hasStatusUpdatesInUnit = !!statusUpdatesCloudId && statusUpdatesCloudId !== currentCloudId;

	const isStatusUpdatesEnabled = hasProjectsAccess || hasGoalsAccess;

	const route = hasProjectsAccess ? projectUpdateViewRoute : goalUpdateViewRoute;
	const basePath = generatePath(route, routeDependencies);

	// If gate is off or current site has status updates, return base path
	if (!unitsEnabled || hasStatusUpdatesInCurrentSite) {
		return { statusUpdatesPath: basePath, isStatusUpdatesEnabled };
	}

	// If status updates is enabled in the unit, return path with cloudId
	if (hasStatusUpdatesInUnit) {
		const queryParams = createSearchParamsFromCurrentUrl({ cloudId: statusUpdatesCloudId });
		const route = hasProjectsAccess ? projectUpdateViewRoute : goalUpdateViewRoute;
		const basePath = generatePath(route, routeDependencies);

		return { statusUpdatesPath: `${basePath}?${queryParams.toString()}`, isStatusUpdatesEnabled };
	}

	return { statusUpdatesPath: basePath, isStatusUpdatesEnabled };
};
